import React from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import SellMobile from "./SellMobile";
import SellDesktop from "./SellDesktop";

function Sell({ app, config }) {
  const isMobile = useMediaQuery({ query: "(max-width: 980px)" });

  return isMobile ? (
    <SellMobile app={app} config={config} />
  ) : (
    <SellDesktop app={app} config={config} />
  );
}

Sell.defaultProps = {
  app: null,
  config: {},
};

Sell.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Sell;
